import { sendToMixpanel } from '../../mixpanel';

const trackAgentGetAppraisal = () => {
  sendToMixpanel('Request Appraisal', {
    entryPoint: 'Agency Profile - Our Team',
  });
};

export default trackAgentGetAppraisal;
